import { Box } from "@mui/material";
import React, { useState } from "react";
import {
  ForgotDetailsEmail,
  ForgotDetailsOTP,
  ForgotDetailsPassword,
} from "../../components/authentication/forgot-details";

const ForgotPassword = () => {
  const [path, setPath] = useState(1);
  const [details, setDetails] = useState({
    email: "",
    password: "",
    confirm_password:"",
    otp: "",
  });

  const handleNext = () => {
    setPath((prevPath) => prevPath + 1);
  };
  const handleBack = () => {
    setPath((prevPath) => prevPath - 1);
  };
  return (
    <Box
      sx={{
        background: "white",
        paddingTop: 2,
        width: 500,
        mx: "auto",
        height: "70vh",
      }}
    >
      {path === 1 && <ForgotDetailsEmail details={details} setDetails={setDetails} next={handleNext} prev={handleBack} />}
      {path === 2 && <ForgotDetailsOTP details={details} setDetails={setDetails} next={handleNext} prev={handleBack} />}
      {path === 3 && <ForgotDetailsPassword details={details} setDetails={setDetails} next={handleNext} prev={handleBack} />}
    </Box>
  );
};

export default ForgotPassword;
